import React, { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Switch } from "@headlessui/react";

import { baseUrl } from "../../Environments/environment";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import countries from "../../utils/countries";
import { apiClient } from "../../api";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}
let todayDate = null;
let tomorrowDate = null;
let standardCheckInTime = null;
let standardCheckOutTime = null;

const statuses = [
	"Bookings",
	"Check In",
	"In House",
	"Check Out",
	"Checked Out",
];

const mapStatus = {
	Booking: "Reservation",
	"Check In": "Reservation",
	"In House": "In House",
	"Check Out": "In House",
	"Checked Out": "Checked Out",
};

const reverseMapStatus = {
	Reservation: "Booking",
	"In House": "In House",
	"Checked Out": "Checked Out",
	Cancelled: "Cancelled",
};
function AddGuestModal({ isOpen, onClose }) {
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { accessToken } = useAuth();
  const { selectedPropertyId, propertyTimezone, propertyName } = useProperty();
  const [selectedDiv, setSelectedDiv] = useState(0);
  const [currentStatus, setCurrentStatus] = useState("Booking");
  const [checkInType1, setCheckInType1] = useState("Check In");
  const [checkInType2, setCheckInType2] = useState("Check Out");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(undefined);
  const [source, setSource] = useState(undefined);
  const [confirmationNumber, setConfirmationNumber] = useState(undefined);
  const [arrivalDate, setArrivalDate] = useState();
  const [arrivalTime, setArrivalTime] = useState();
  const [departureDate, setDepartureDate] = useState();
  const [departureTime, setDepartureTime] = useState();
  const [roomNumber, setRoomNumber] = useState(undefined);
  const [roomType, setRoomType] = useState(undefined);
  const [firstName, setFirstName] = useState(undefined);
  const [lastName, setLastName] = useState(undefined);
  const [email, setEmail] = useState(undefined);
  const [sendMessage, setSendMessage] = useState(true);
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [message, setMessage] = useState(undefined);
  const [guestAddingLoader, setGuestAddingLoader] = useState(false);
  const [customFlows, setCustomFlows] = useState();
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState(undefined);
  const [selectedRoomTypeId, setSelectedRoomTypeId] = useState(undefined);
  const [roomNumberError, setRoomNumberError] = useState(false);
  const [roomTypeError, setRoomTypeError] = useState(false);
  const checkIn = `${arrivalDate}T${arrivalTime}Z`;
  const checkOut = `${departureDate}T${departureTime}Z`;
  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

		const formatDate = (date) => {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			return `${year}-${month}-${day}`;
		};

		todayDate = formatDate(today);
		tomorrowDate = formatDate(tomorrow);
		setArrivalDate(formatDate(today));
		setDepartureDate(formatDate(tomorrow));
	}, [isOpen]);
	useEffect(() => {
		const handleClickOutside = (event) => {
			// Check if click is outside both the dropdown and the trigger button
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
				setSearchTerm("");
			}
		};

		// Only add the event listener if the dropdown is open
		if (isDropdownOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isDropdownOpen]);
	const toggleDropdown = (e) => {
		e.stopPropagation();
		setIsDropdownOpen(!isDropdownOpen);
		if (!isDropdownOpen) {
			// Reset search when opening
			setSearchTerm("");
			// Focus search input after opening
			setTimeout(() => {
				searchInputRef.current?.focus();
			}, 0);
		}
	};

	const setTiming = async () => {
		try {
			// Send the data in a POST request
			// console.log("url", baseUrl);
			if (!standardCheckInTime || !standardCheckOutTime) {
				const response = await apiClient.get(
					`${baseUrl}/setting/${selectedPropertyId}`,
				);
				if (response.ok) {
					const newToken = response.headers.get("Authorization");
					if (newToken) {
						localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
					}
				}
				standardCheckInTime = response.data.result.setting.standardCheckinTime;
				standardCheckOutTime =
					response.data.result.setting.standardCheckoutTime;
			}
			setArrivalTime(standardCheckInTime);
			setDepartureTime(standardCheckOutTime);
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};
	useEffect(() => {
		setTiming();
		// eslint-disable-next-line
	}, [isOpen]);

	useEffect(() => {
		if (checkInType1 === "Early Check In") {
			// setArrivalDate(todayDate);
			setArrivalTime("");
		} else if (checkInType1 === "Check In") {
			setArrivalDate(todayDate);
			setArrivalTime(standardCheckInTime);
		} else if (
			checkInType1 === "Cancel Reservation" &&
			checkInType1 === "No Show" &&
			currentStatus === "In House"
		) {
			// setArrivalDate(todayDate);
			setArrivalTime(standardCheckInTime);
			// setDepartureDate(tomorrowDate);
			setDepartureTime(standardCheckOutTime);
		} else if (currentStatus === "Checked Out") {
			setArrivalDate(todayDate);
			setArrivalTime(standardCheckInTime);
			setDepartureDate(tomorrowDate);
			setDepartureTime(standardCheckOutTime);
		} else if (
			checkInType1 === "Cancel Reservation" ||
			checkInType1 === "No Show"
		) {
			setArrivalDate("");
			setArrivalTime("");
			setDepartureDate("");
			setDepartureTime("");
		}
	}, [checkInType1, currentStatus]);

	useEffect(() => {
		if (checkInType2 === "Late Check Out") {
			setDepartureDate(tomorrowDate);
			setDepartureTime("");
		} else if (
			checkInType2 === "Check Out" &&
			checkInType1 !== "Cancel Reservation" &&
			checkInType1 !== "No Show"
		) {
			setDepartureDate(tomorrowDate);
			setDepartureTime(standardCheckOutTime);
		}
	}, [checkInType2, checkInType1]);

	const getCustomFlows = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/customFlow/${selectedPropertyId}`,
			);
			if (response.status === 200) {
				const newToken = response.headers["authorization"];
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]);
				}

        if (response.data?.result?.length > 0) {
          console.log("DATAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response.data);
          setCustomFlows([...response.data.result].reverse());
        } else {
          console.warn("No flows found");
          //console.log(response.data.result)
          setCustomFlows([...response.data.result.customFlow].reverse());
        }
      } else {
        console.error("API error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getRoomTypes = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await apiClient.get(
        `${baseUrl}/upgradeRoomWorkflow/roomType/${selectedPropertyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const newToken = response.headers["authorization"];
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]);
        }
        setRoomTypes(response.data.result.roomType);
        console.log("Room Data Fetched :", response.data.result.roomType);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getCustomFlows();
    getRoomTypes();
  }, [isOpen]);

	if (!isOpen) return null;
	const toggleMessageVisibility = () => {
		setIsMessageVisible(!isMessageVisible);
	};

  const resetFields = () => {
    setCurrentStatus("Booking");
    setSelectedDiv(0);
    setCheckInType1("Check In");
    setCheckInType2("Check Out");
    setCountryCode("+1");
    setPhoneNumber();
    setSource();
    setConfirmationNumber();
    setArrivalDate();
    setArrivalTime();
    setDepartureDate();
    setDepartureTime();
    setRoomNumber();
    setSelectedRoomType();
    setSelectedRoomTypeId();
    setFirstName();
    setLastName();
    setEmail();
    setSendMessage(true);
    setIsMessageVisible(false);
  };

	// const sendCustomMessages = async (status,guest) => {
	// 	const bodyData = {
	// 		messageId: "66b8e563d932866db03735d6",
	// 		sendMessage: true,
	// 		status,
	// 		guest
	// 	}
	// 	try {
	// 		const response = await apiClient.post(
	// 			`${baseUrl}/customMessage/${selectedPropertyId}`,
	// 			bodyData
	// 		);
	// 		console.log("Response ------",response.data)
	// 	} catch (error) {
	// 		console.error("-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",error)
	// 	}
	// }

	const sendCustomMessages = async (status, guest) => {
		if (!customFlows || customFlows.length == 0) {
			await getCustomFlows();
		}
		console.log(customFlows);
		const filteredFlows = customFlows.filter(
			(flow) =>
				flow.trigger.toLowerCase() === "after guest moved to in-house" &&
				flow.flowStatus == true,
		);

		console.log(status);
		if (status.currentStatus === "In House") {
			for (const flow of filteredFlows) {
				const bodyData = {
					messageId: flow.messageTemplateId,
					sendMessage: true,
					status,
					guest,
				};
				console.log(flow);
				try {
					const response = await apiClient.post(
						`${baseUrl}/customMessage/${selectedPropertyId}`,
						bodyData,
					);
					console.log("Response ------", response.data);
				} catch (error) {
					console.error(
						"-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",
						error,
					);
				}
			}
		}
	};

  const handleAddGuest = async () => {
    let status = { currentStatus };
    if (checkInType1 === "Early Check In") {
      status.earlyCheckInStatus = "Accepted";
    }
    if (checkInType1 === "Cancel Reservation") {
      status.reservationStatus = "Cancelled";
    }
    if (checkInType1 === "No Show") {
      status.reservationStatus = "No Show";
    }
    if (checkInType2 === "Late Check Out") {
      status.lateCheckOutStatus = "Accepted";
    }
    const capitalizeFirstLetter = (str) => {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : undefined;
    };
    status.currentStatus =
      status.currentStatus === "Booking"
        ? "Reservation"
        : status.currentStatus === "Checked Out"
          ? "Checked Out"
          : status.currentStatus;
    const guestData = {
      email: email === "" ? undefined : email,
      source: source === "" ? undefined : source,
      status,
      checkIn,
      checkOut,
      lastName: lastName === "" ? undefined : capitalizeFirstLetter(lastName),
      firstName:
        firstName === "" ? undefined : capitalizeFirstLetter(firstName),
      // countryCode,
      // phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
      countryCode: !phoneNumber ? undefined : countryCode,
      phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
      confirmationNumber:
        confirmationNumber === "" ? undefined : confirmationNumber,
      sendMessage,
        ...(currentStatus !== "Booking" && {
          roomNumber: roomNumber === "" ? undefined : roomNumber,
          roomType: selectedRoomTypeId ? parseInt(selectedRoomTypeId, 10) : undefined,
        }),
    };

    // Validate room number is required for non-booking status
    if (
      currentStatus !== "Booking" &&
      (!roomNumber || roomNumber.trim() === "")
    ) {
      setRoomNumberError(true);
      toast.error("Room number is required");
      return;
    } else {
      setRoomNumberError(false);
    }

    // Validate room type is required for non-booking status
    if (
      currentStatus !== "Booking" &&
      (!selectedRoomTypeId || selectedRoomTypeId === "")
    ) {
      setRoomTypeError(true);
      toast.error("Room type is required");
      return;
    } else {
      setRoomTypeError(false);
    }

    try {
       console.log(guestData);
      // console.log("urllll", baseUrl);
      // eslint-disable-next-line
      setGuestAddingLoader(true);
      const response = await apiClient.post(
        `${baseUrl}/guest/${selectedPropertyId}`,
        guestData,
      );
      //console.warn(response.data)
      const newGuest = response.data.result.guest;
      await sendCustomMessages(newGuest.status, newGuest);
      //const customMessage =
      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }
      setGuestAddingLoader(false);
      toast.success(response.data.message);
      // Reset state values after successful API call
      resetFields();
      onClose();
    } catch (error) {
      // console.log(error);
      setGuestAddingLoader(false);
      let errorMessage =
        error.response?.data?.message ||
        "Failed to add the guest. Please try again.";
      if (error.response?.data?.error.firstName !== undefined) {
        errorMessage =
          "First name is " + error.response?.data?.error.firstName[0];
      } else if (error.response?.data?.error.lastName !== undefined) {
        errorMessage =
          "Last name is " + error.response?.data?.error.lastName[0];
      } else if (
        error.response?.data?.error.phoneNumber !== undefined &&
        phoneNumber === undefined
      ) {
        errorMessage = error.response?.data?.error.phoneNumber[0];
      } else if (error.response?.data?.error.phoneNumber !== undefined) {
        errorMessage = error.response?.data?.error.phoneNumber[0];
      } else if (error.response?.data?.error.checkIn !== undefined) {
        errorMessage = "For Check In " + error.response?.data?.error.checkIn[0];
      } else if (error.response?.data?.error.checkOut !== undefined) {
        errorMessage =
          "For Check Out " + error.response?.data?.error.checkOut[0];
      } else if (error.response?.data?.error.email !== undefined) {
        errorMessage = error.response?.data?.error.email[0];
      } else if (error.response?.data?.error.roomNumber !== undefined) {
        errorMessage = error.response?.data?.error.roomNumber[0];
      }
      // console.log(error.response?.data?.error);
      toast.error(errorMessage);
    }
  };

	const handleDivClick = (index, text) => {
		if (selectedDiv === index) {
			setSelectedDiv(0);
			setCurrentStatus("Reservation");
		} else {
			setSelectedDiv(index);
			setCurrentStatus(text);
		}
	};

	const filteredCountries = countries.filter((country) =>
		country.name.toLowerCase().includes(searchTerm.toLowerCase()),
	);

	const handleCountrySelect = (country) => {
		setSelectedCountry(country);
		setCountryCode(country.code);
		setSearchTerm(""); // Clear search term on selection
		setIsDropdownOpen(false); // Close the dropdown
	};

	const statusoptions = [
		{ id: 1, text: "Booking" },
		{ id: 2, text: "In House" },
		{ id: 3, text: "Checked Out" },
	];

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			{/* New Guest Modal */}
			<div
				className={`bg-white p-6 rounded-lg shadow-xl lg:w-[70vh] ${
					isMessageVisible && "lg:h-[90vh] overflow-auto"
				} space-y-7`}
			>
				<div className="flex justify-between items-center">
					<h2 className="text-lg font-semibold">New Booking</h2>
					<button
						onClick={() => {
							resetFields();
							onClose();
						}}
						className="text-gray-600 hover:text-gray-900"
					>
						<AiOutlineClose size={20} />
					</button>
				</div>

				<div className="w-full space-y-5">
					<div className="flex items-center justify-between">
						{statusoptions.map((div, index) => (
							<div
								key={div.id}
								className={`flex items-center justify-center h-[7vh] w-[20vh] p-4 border border-solid rounded-[2vh] border-[#D1D5DB] cursor-pointer text-center text-sm font-semibold ${
									selectedDiv === index
										? "bg-[#EEF2FF] border-indigo-600"
										: "bg-white text-black"
								}`}
								onClick={() => handleDivClick(index, div.text)}
							>
								{div.text}
							</div>
						))}
					</div>

					<hr />

					<div className="flex space-x-4">
						<div className="w-1/2">
							<label
								className={`block text-[13px] font-semibold  mb-1 text-gray-700
           `}
							>
								First Name
							</label>
							<input
								type="text"
								value={firstName}
								onChange={(e) => setFirstName(e.target.value)}
								className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
							/>
						</div>
						<div className="w-1/2">
							<label
								className={`block text-[13px] font-semibold  mb-1 text-gray-700
              `}
							>
								Last Name
							</label>
							<input
								type="text"
								value={lastName}
								onChange={(e) => setLastName(e.target.value)}
								className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
							/>
						</div>
					</div>

					<div className="space-y-4 w-full max-w-2xl">
						<div className="space-y-2">
							<label className="block text-sm font-medium text-gray-700">
								Phone Number
							</label>
							<div className="relative">
								<div className="flex">
									<div className="relative w-[120px]">
										<button
											type="button"
											onClick={toggleDropdown}
											className="w-full h-full flex items-center justify-between px-3 py-2 border border-gray-300 bg-white rounded-l-md text-sm hover:bg-gray-50"
										>
											<span className="flex items-center gap-2">
												{selectedCountry ? (
													<>
														<span>{selectedCountry.code}</span>
													</>
												) : (
													"+1"
												)}
											</span>
											<svg
												className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
													isDropdownOpen ? "rotate-180" : ""
												}`}
												viewBox="0 0 20 20"
												fill="currentColor"
											>
												<path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
											</svg>
										</button>
									</div>
									<input
										type="tel"
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
										placeholder="Enter phone number"
										className="flex-1 rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
									/>
								</div>

								{/* Dropdown */}
								{isDropdownOpen && (
									<div
										ref={dropdownRef}
										className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
									>
										<div className="p-2">
											<input
												ref={searchInputRef}
												type="text"
												value={searchTerm}
												onChange={(e) => setSearchTerm(e.target.value)}
												placeholder="Search country..."
												className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
											/>
										</div>
										<div className="max-h-60 overflow-y-auto">
											{filteredCountries.map((country) => (
												<div
													key={country.code}
													className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3 text-sm"
													onClick={() => handleCountrySelect(country)}
												>
													<span className="text-lg">{country.flag}</span>
													<span className="text-gray-700">{country.name}</span>
													<span className="text-gray-500 ml-auto">
														{country.code}
													</span>
												</div>
											))}
											{filteredCountries.length === 0 && (
												<div className="px-4 py-2 text-sm text-gray-500">
													No countries found
												</div>
											)}
										</div>
									</div>
								)}
							</div>
						</div>

						<div className="space-y-2">
							<label className="block text-sm font-medium text-gray-700">
								Email
							</label>
							<input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="Enter your email"
								className="w-full rounded-md border border-gray-300 
                   px-3 py-2 text-sm text-gray-700 
                   focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                   placeholder:text-gray-400"
							/>
						</div>
					</div>

					{/* <div className="w-full mb-4 mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number
            </label>
            <div className="flex">
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="rounded-l-md  border border-gray-300 px-5 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
              >
                <option value="+1">+1</option>
                <option value="+91">+91</option>
              </select>
              <input
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="flex-grow rounded-r-md border-t border-r border-b block w-full  border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                placeholder="Phone number"
              />
            </div>
          </div> */}

					<div className="">
						<label className="block text-[13px] font-semibold text-gray-700 mb-1">
							Registration Details
						</label>

						<div className="flex">
							<div className="w-1/2">
								<select
									value={checkInType1}
									onChange={(e) => setCheckInType1(e.target.value)}
									placeholder="Car Type"
									className={`block w-full border border-b-0 rounded-tl-md border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light ${
										(
											checkInType1 === "Cancel Reservation" ||
												checkInType1 === "No Show"
										) && currentStatus !== "Booking"
											? "bg-rose-50"
											: ""
									}`}
								>
									<option value="Check In">Check In</option>
									<option value="Early Check In">Early Check In</option>
									{currentStatus === "Booking" && (
										<>
											<option value="Cancel Reservation">
												Cancel Reservation
											</option>
											<option value="No Show">No Show</option>
										</>
									)}
								</select>
							</div>
							<div className="w-1/2">
								<select
									value={checkInType2}
									onChange={(e) => setCheckInType2(e.target.value)}
									placeholder="Car Type"
									// disabled={checkInType1 === "Cancel Reservation" ? true : false}
									className="block w-full border border-b-0 rounded-tr-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light"
								>
									<option value="Check Out">Check Out</option>
									<option value="Late Check Out">Late Check Out</option>
								</select>
							</div>
						</div>
						{/* <select
              value={checkInType}
              onChange={(e) => setCheckInType(e.target.value)}
              placeholder="Car Type"
              className="block w-full border border-b-0 rounded-t-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
            >
              <option value="" style={{ color: "#9e9e9e" }}>
                Standard Check In
              </option>
              <option value="eci">Early Check In</option>
              <option value="lco">Late Check Out</option>
            </select> */}
						{/* {console.log(checkInType)} */}
						{/* {console.log(selectedPropertyId)} */}
						{/* {console.log(currentStatus)} */}

						<div className="flex">
							<div className="w-1/4">
								<input
									type="date"
									id="arrivalDate"
									value={arrivalDate}
									onChange={(e) => {
										const newArrival = e.target.value;
										setArrivalDate(newArrival);

										setDepartureDate(
											new Date(newArrival) >= new Date(departureDate)
												? new Date(
														new Date(newArrival).getTime() +
															24 * 60 * 60 * 1000,
													)
														.toISOString()
														.split("T")[0]
												: departureDate,
										);
									}}
									className={`block w-full border border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] ${
										checkInType1 === "Early Check In"
											? "text-gray-900"
											: "text-gray-400"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="time"
									id="arrivalTime"
									value={arrivalTime}
									disabled={checkInType1 === "Check In" ? true : false}
									onChange={(e) => {
										setArrivalTime(e.target.value);
									}}
									className={`block w-full border border-l-0 border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light ${
										checkInType1 === "Early Check In"
											? "text-gray-900"
											: "text-gray-400"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="date"
									id="departureDate"
									value={departureDate}
									onChange={(e) => setDepartureDate(e.target.value)}
									min={arrivalDate}
									className={`block w-full border border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
										checkInType2 === "Check Out"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="time"
									id="departureTime"
									value={departureTime}
									onChange={(e) => setDepartureTime(e.target.value)}
									disabled={
										checkInType2 === "Check Out" &&
										checkInType1 !== "Cancel Reservation" &&
										checkInType1 !== "No Show"
											? true
											: false
									}
									className={`block w-full border border-l-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] placeholder:text-gray-300 placeholder:font-light ${
										checkInType2 === "Check Out"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
						</div>

						<div className="flex">
							<div className="w-1/2">
								<input
									type="text"
									value={confirmationNumber}
									onChange={(e) => setConfirmationNumber(e.target.value)}
									className="block w-full border border-t-0 border-r-0 rounded-bl-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-400 placeholder:font-light"
									placeholder="Confirmation number"
								/>
							</div>
							<div className="w-1/2">
								<select
									value={source}
									onChange={(e) => setSource(e.target.value)}
									placeholder="Car Type"
									className="block w-full border border-t-0 rounded-br-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light"
								>
									<option value="" style={{ color: "#9e9e9e" }}>
										Select source
									</option>
									<option value="booking">Booking.com</option>
									<option value="expedia">Expedia</option>
									<option value="airbnb">Airbnb</option>
									<option value="google">Google</option>
									<option value="ctrip">C-Trip</option>
									<option value="hotels">Hotels.com</option>
									<option value="HotelsWebsite">Hotels website</option>
								</select>
							</div>
						</div>

            {selectedDiv === 0 ? (
              <></>
            ) : (
              <>
                <div className="w-full mt-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-[13px] font-semibold text-gray-700 mb-1">
                        Room Number
                      </label>
                      <input
                        type="text"
                        value={roomNumber}
                        onChange={(e) => setRoomNumber(e.target.value)}
                        className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] placeholder:text-gray-300 placeholder:font-light"
                      />
                    </div>
                    <div>
                      <label className="block text-[13px] font-semibold text-gray-700 mb-1">
                        Room Type
                      </label>
                      <select
                        value={selectedRoomTypeId || ""}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          setSelectedRoomTypeId(selectedId);
                          
                          // Find the selected room type object to get its name for display
                          const selectedRoomTypeObj = roomTypes.find(roomType => 
                            roomType.id.toString() === selectedId
                          );
                          
                          if (selectedRoomTypeObj) {
                            setSelectedRoomType(selectedRoomTypeObj.name || selectedRoomTypeObj.roomType);
                            console.log("Selected Room Type ID:", selectedRoomTypeObj.id);
                            console.log("Selected Room Type Name:", selectedRoomTypeObj.name || selectedRoomTypeObj.roomType);
                            console.log("Full Room Type Object:", selectedRoomTypeObj);
                          } else {
                            setSelectedRoomType("");
                          }
                        }}
                        className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px]"
                      >
                        <option value="">Select Room Type</option>
                        {roomTypes && roomTypes.length > 0 ? (
                          roomTypes.map((roomType, index) => (
                            <option key={index} value={roomType.id}>
                              {roomType.name || roomType.roomType}
                            </option>
                          ))
                        ) : (
                          <option disabled>No room types available</option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* <div className="flex mb-4 space-x-4">
            <div className="w-1/2">
              <label
                className={`block text-sm font-medium  mb-2 text-gray-700
           `}
              >
                First Name
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                placeholder="Enter first name"
              />
            </div>
            <div className="w-1/2">
              <label
                className={`block text-sm font-medium  mb-2 text-gray-700
              `}
              >
                Last Name
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                placeholder="Enter last name"
              />
            </div>
          </div> */}
					{/* <div className="w-full">
            <label
              className={`block text-sm font-medium  mb-1 text-gray-700
            `}
            >
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
              placeholder="Enter email"
            />
          </div> */}

					{/* {selectedDiv === 0 ? (
            <></>
          ) : (
            <>
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Room Number
                </label>
                <input
                  type="text"
                  value={roomNumber}
                  onChange={(e) => setRoomNumber(e.target.value)}
                  className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                />
              </div>
            </>
          )} */}
				</div>

				<div>
					<div className="flex flex-col lg:flex-row items-center justify-between">
						{/* Switch */}
						<div className="flex items-center mb-2 lg:mb-0">
							<Switch
								checked={sendMessage}
								onChange={setSendMessage}
								className={classNames(
									sendMessage ? "bg-indigo-600" : "bg-gray-200",
									"relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
								)}
							>
								<span className="sr-only">Use setting</span>
								<span
									aria-hidden="true"
									className={classNames(
										sendMessage ? "translate-x-5" : "translate-x-0",
										"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
									)}
								/>
							</Switch>
							<div className="justify-start">
								<div>
									<label
										htmlFor="toggle"
										className="ml-2 text-[13px] font-medium text-[#111827]"
									>
										Message Guest
									</label>
								</div>
								{/* <label
                  htmlFor="toggle"
                  className="ml-2 text-sm font-medium text-[#111827]"
                >
                  Message Guest
                </label> */}
								<div className="-mt-1.5">
									<button
										className="text-gray-400 pl-2 text-xs"
										onClick={toggleMessageVisibility}
									>
										{isMessageVisible ? (
											<>
												<div className="flex">
													<div className="pr-1">Hide Message</div>
													<IoIosArrowUp />
												</div>
											</>
										) : (
											<>
												<div className="flex">
													<div className="pr-1">View Message</div>
													<IoIosArrowDown />
												</div>
											</>
										)}
									</button>
								</div>
							</div>
						</div>
						{/* Add Guest Button */}
						<button
							onClick={handleAddGuest}
							className="lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
						>
							{guestAddingLoader ? "Booking..." : "New Booking"}
						</button>
					</div>
					<div className="w-full mt-2">
						{isMessageVisible && (
							<textarea
								value={
									checkInType1 === "Cancel Reservation"
										? `Your reservation at ${propertyName} has been cancelled. Reply here for questions.`
										: checkInType1 === "Early Check In" &&
												checkInType2 === "Check Out"
											? `Your early check-in at ${propertyName} is confirmed. Check-in available at ${new Date(
													checkIn,
												).toLocaleString("en", {
													day: "2-digit",
													month: "2-digit",
													hour: "2-digit",
													minute: "2-digit",
													hour12: true,
													timeZone: "UTC",
												})}${propertyTimezone}. Reply here for questions.`
											: checkInType2 === "Late Check Out" &&
													checkInType1 === "Check In"
												? `Your late check-out request at ${propertyName} is accepted. Check out by ${new Date(
														checkOut,
													).toLocaleString("en", {
														day: "2-digit",
														month: "2-digit",
														hour: "2-digit",
														minute: "2-digit",
														hour12: true,
														timeZone: "UTC",
													})}${propertyTimezone}. Reply here for questions.`
												: checkInType1 === "Early Check In" &&
														checkInType2 === "Late Check Out"
													? `Both early check-in and late check-out requests at ${propertyName} are accepted! Early check-in at ${new Date(
															checkIn,
														).toLocaleString("en", {
															day: "2-digit",
															month: "2-digit",
															hour: "2-digit",
															minute: "2-digit",
															hour12: true,
															timeZone: "UTC",
														})}${propertyTimezone} and late check-out at ${new Date(
															checkOut,
														).toLocaleString("en", {
															day: "2-digit",
															month: "2-digit",
															hour: "2-digit",
															minute: "2-digit",
															hour12: true,
															timeZone: "UTC",
														})}${propertyTimezone}. Reply here for questions.`
													: `Your reservation at ${propertyName} is confirmed! We look forward to welcoming you on ${new Date(
															checkIn,
														).toLocaleString("en", {
															day: "2-digit",
															month: "2-digit",
															hour: "2-digit",
															minute: "2-digit",
															hour12: true,
															timeZone: "UTC",
														})}${propertyTimezone}. Reply here for questions.`
								}
								// onChange={(e) => setMessage(e.target.value)}
								className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto text-[13px] placeholder:text-gray-900"
								rows="2"
								placeholder="Default status message template text goes here and not editable..."
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default AddGuestModal;
